import { put } from '@core/api/baseApi';
import { User } from '../../../../core/types/User';

export const updateUser = async (payload: User): Promise<void> => await put(`/Users`, payload);

